import React from 'react';
import PropTypes from 'prop-types';
import {Card, Col, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";

const BaseDetailsPageHeader = ({title, iconBar}) => {
    const navigate = useNavigate();
    return (
        <Card className={"mb-3"}>
            <Card.Header>
                <Row>
                    <a onClick={() => {navigate(-1)}} title={"Go back to the previous page"} className={"h6 link-secondary text-600 cursor-pointer"}>
                        <FontAwesomeIcon icon={"chevron-left"} aria-hidden={true} className={"me-2"} />
                        BACK
                    </a>
                </Row>
                <Row as={'hgroup'}>
                    <Col>
                        <h1 className={"mb-2 h5"}>{title}</h1>
                    </Col>
                    <Col xs={"auto"}>{iconBar}</Col>
                </Row>
            </Card.Header>
        </Card>
    )
}
BaseDetailsPageHeader.propTypes = {
    title: PropTypes.node.isRequired,
    iconBar: PropTypes.node.isRequired,
}
export default BaseDetailsPageHeader